import { CreateWithdrawal } from "../models/Invoices";
import { CreateSendPayload } from "../models/Envio";
import { CreateWallet } from "../models/Wallet";
import { Api } from "./Api";
import { apiUrl } from "../enviroments/enviroments.dev";

const target = "/invoices";

export class InvoiceService {

    public static createWithdrawal (payload:CreateWithdrawal, id:number) {
        return Api.post(apiUrl(target+"/create/withdrawal/"+id), {payload});
    }

    // Envio da empresa p/ cliente (debita empresa + cliente). org no body.
    public static createSend (payload: CreateSendPayload) {
        return Api.post(apiUrl(target + "/send"), payload);
    }

    public static getWithdrawalByOrganization (id:number) {
        return Api.get(apiUrl(target+"/list/organization/"+id));
    }

    // Saques/envios de um cliente.
    public static getByUser (userId:number) {
        return Api.get(apiUrl(target+"/user/"+userId));
    }

    // Marca o envio/invoice como concluído (COMPLETED).
    public static confirm (id: number | string) {
        return Api.patch(apiUrl(target + "/" + id + "/confirm"), {});
    }
}
